angular.module('PatientApp').controller('EstimateDetailsCtrl', function($q, $scope, $rootScope, $state, $interval, Compass, $filter, EstimatesService){
    
    var _id = $state.params.estimateId;

    if (!_id) {
        $state.go('app.default');
    }

    $scope.showLoading = true;
    
    $scope.getEstimate = function() {
        EstimatesService.getAccountEstimate(_id).then(function(resp) {
            $scope.estimate = resp;
            $scope.showLoading = false;
        }).catch(function() {
            Compass.capture.failure('estimate', 'id', '');
            $state.go('app.default');
        });
    };

    $scope.makePayment = function() {
        $state.go('app.payment.start', {estimateId: _id});
    };

    $scope.messageProvider = function() {
        $rootScope.$emit('message:compose', { estimateId: _id, reason: 11 });
    };

    $scope.getEstimate();
});
